import React from 'react';
import { Link } from 'react-router-dom';
import Footer from '../components/Footer';

const PrivacyPage: React.FC = () => {
  return (
    <>
      <main className="min-vh-100">
        <div className="container py-4 py-md-5 px-3 px-md-0">
          <div className="row justify-content-center">
            <div className="col-lg-8">
              <Link to="/" className="privacy-page__back">
                <i className="bi bi-arrow-left" aria-hidden="true" />
                Back to home
              </Link>

              <span className="section-eyebrow d-block mt-3">Legal</span>
              <h1 className="section-title mt-2">Privacy &amp; Data Policy</h1>
              <p className="lead text-muted">
                Bothasig Muslim and Cultural Society (BMCS) values your privacy and handles all information in line
                with South Africa&apos;s Protection of Personal Information Act (POPIA).
              </p>

              <div className="mt-4 privacy-page__body text-muted">
                <h2 className="h5 text-body mt-4 mb-2">Site Analytics (Opt-In Only)</h2>
                <p>
                  When you first visit, we ask whether you are comfortable with us collecting anonymous browsing
                  details, such as which pages or notices are viewed most often. This helps us understand what
                  content matters most to our community so we can keep improving the site.
                </p>
                <p>
                  <strong className="text-body">If you accept:</strong> We record anonymous page views. We never use
                  this data to identify you by name, and we will never sell your information.
                </p>
                <p>
                  <strong className="text-body">If you decline (or before you choose):</strong> No browsing information
                  is collected or sent from your browser.
                </p>

                <h2 className="h5 text-body mt-4 mb-2">Account Access &amp; Administrative Sign-In</h2>
                <p>
                  Sign-in features are strictly reserved for authorized committee members and operational staff to
                  manage society operations. They are not meant for general community registration. Any personal
                  details associated with these administrative accounts are kept secure and used solely for legitimate
                  society business.
                </p>

                <h2 className="h5 text-body mt-4 mb-2">Data Security</h2>
                <p>
                  We take practical and reasonable measures to safeguard personal information against loss, misuse,
                  and unauthorized access.
                </p>

                <h2 className="h5 text-body mt-4 mb-2">Your Rights Under POPIA</h2>
                <p className="mb-0">
                  You have the right to request access to your personal details, ask for corrections, or object to
                  specific processing of your information. If you have any questions or requests, feel free to contact
                  us through the details listed in our footer.
                </p>
              </div>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
};

export default PrivacyPage;
